import React, {useState} from "react";
import ModalRefuseDelivery from "../modals/refuse-delivery";
import i18n from "../../i18n";


export default function RefuseDeliveryButton({deliveryId, isCanRefuse, setLoadingDelivItem, setNeedUpdate, setStopListUpdate}) {
    const [showModal, setShowModal] = useState(false);

    if (!isCanRefuse)
        return null;

    const onCLickShowModal = () => {
        setStopListUpdate(true);
        setShowModal(true);
    };

    return (
        <>
            <button className="btn typical-btn typical-btn-red" onClick={onCLickShowModal}>
              {i18n.t('components.refuseDeliveryButton.buttons.refuse')}
            </button>
            <ModalRefuseDelivery
                isShow={showModal}
                setIsShow={setShowModal}
                deliveryId={deliveryId}
                setLoadingDelivItem={setLoadingDelivItem}
                setNeedUpdate={setNeedUpdate}
                setStopListUpdate={setStopListUpdate}
            />
        </>
    );
}
